export default "__VITE_ASSET__BIW5H7gj__"